export default "__VITE_ASSET__DT4SHvIK__"